import React from 'react'
import { Stack, Table, TableBody, Grid, TableCell, TableContainer, TableHead, TableRow, Box, Button, TablePagination, Paper } from '@mui/material'
import moment from 'moment/moment'
import { useState } from 'react'
import { Item } from '../../../../common/snippets'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { excelHeader1, pdfHeaderColumn } from '../BookingConstants'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../../common/font/Roboto-Medium-normal'
import { focusElemnt, navigation3 } from '../../../../common/helper'
import { RenderTable } from '../../analysisReport/summmaryTable'
import { RenderTableExcel } from '../../analysisReport/summaryTableExcel'
import { makeTable } from '../../analysisReport/pdfAutotable'
import { useSelector } from 'react-redux'

const OwnBookingSummary = ({ checkCrossinglr, loginData, tableData, fromDate, toDate, sourceCity, sourceBranch, sourceBranchUser, destinationCity, destinationBranch, paymentType, transactionType, selReportView, status, disableExcel ,headers}) => {
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const [showTable, setShowTable] = useState(true)
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  var totalPagesExp = '{total_pages_count_string}'
  const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
    const doc = data.doc
    var pageSize = doc.internal.pageSize
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

    var str = 'Page : ' + doc.internal.getNumberOfPages()
    if (typeof doc.putTotalPages === 'function') {
      str = str + ' of ' + totalPagesExp
    }
    doc.setFontSize(16)
    doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, 'right')
    doc.setFont('Roboto', 'bold')
    doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
    doc.text(
      `Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`,
      doc.internal.pageSize.width / 2 -
      (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) /
      2 +
      90,
      pageHeight - 5
    )
  }
  function pdfLogoDraw(data, doc) {
    doc.setTextColor(0, 0, 0)
    doc.setFontSize(18)
    doc.setFont('Roboto', 'bold')
    doc.text(`Report View: Summary`, 30, 170)
    doc.setFontSize(18)
    doc.setFont('Roboto', 'bold')
    doc.text(`Inclusive Crossing LRs: ${checkCrossinglr ? 'Yes' : 'No'}`, doc.internal.pageSize.width - data.settings.margin.left, 170, 'right')
    doc.setTextColor(0, 0, 0)
    doc.setFontSize(18)
    doc.setFont('Roboto', 'bold')
    doc.text(`Booking Date : ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`, 30, 145)
    doc.setFontSize(18)
    doc.setFont('Roboto', 'bold')
    doc.text(`Report: Own Bookings`, doc.internal.pageSize.width - data.settings.margin.left, 145, 'right')
    doc.setTextColor(40)
    doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
    doc.setFontSize(26).setFont('Roboto', 'bold')
    doc.setTextColor(16, 79, 162)
    doc.text('Cargo System | Own Booking Reports', 30 + 60, 80)
    doc.setTextColor(0, 0, 0)
    doc.setFontSize(22).setFont('Roboto', 'bold')
    doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
    jsPdfHeaderFooter(data, loginData, totalPagesExp)
  }
  const generatepdf = (isSave) => {
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumns = pdfHeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfColumns = headers.map(col => ({ header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }));
    const HeaderData = [
      {
        sourceCity: sourceCity?.SourceCityName,
        sourceBranch: sourceBranch?.SourceBranchName,
        sourceBranchUser: sourceBranchUser?.UserBooked,
        destCity: destinationCity?.DestCityName,
        destBranch: destinationBranch?.DestBranchName,
        paymentType: paymentType?.name,
        trnsType: transactionType?.TransType,
        status: status?.LrStatus,
        dataType: 'entry'
      },
    ]

    const doc = new jsPDF({ orientation: 'p', format: [1080, 1528], unit: 'px', compress: true })
    doc.autoTableSetDefaults({
      headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
    })

    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Item List.pdf`,
      subject: 'Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    makeTable(doc, autoTable, HeaderColumns, HeaderData, 1, '', loginData, "everyPage", () => { }, 200,false)
    makeTable(doc, autoTable, pdfColumns, tableData, 1, '', loginData, "never", pdfLogoDraw)
    doc.setFont('Roboto')
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Own ${'Booking'} Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        document.getElementById('ownBooingDetailed').data = doc.output('datauristring', 'Booking Report')
        focusElemnt('backBtn')
      }, 2000)
    } setTimeout(() => {
      setState({ ...state, generatePDF: false, load: true })
      document.getElementById('ownBooingDetailed').data = doc.output('datauristring', 'Item List.pdf')
      focusElemnt('backBtn')
    }, 2000)

  }
  const printClick = (isSave) => {
    setShowTable(false)
    generatepdf(isSave)
  }

  return (
    <>
      <Item className="userReport">
        <Item style={{ padding: '8px 0 0 15px' }} className="userReport-heading">Report For: Own Bookings</Item>
        <Item className="userReport-buttons">
          {showTable ? (
            <>
              {disableExcel ? (
                <Box>
                  <Button variant="outlined" className="userWisereporttembtn" disabled={true}>
                    Export to Excel
                  </Button>
                </Box>
              ) : (
                <Box onKeyDown={(e) => navigation3(e, 'exportAsPdfBtn', 'OwnSplitBtn', () => { })}>
                  <ReactHtmlTableToExcel
                    id="ExpToExlbtn"
                    className="userWisereporttemExcelBtn"
                    table="table-to-xls"
                    filename={`Own Booking Report ${currentDateTime}`}
                    sheet="tablexls"
                    buttonText="Export to Excel"
                  />
                </Box>
              )}
              <Box>
                <Button
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => {
                    setShowTable(false)
                    printClick(true)
                  }}
                  onKeyDown={(e) => navigation3(e, 'PrintBtn', disableExcel ? 'OwnSplitBtn' : 'ExpToExlbtn', () => { generatepdf(true) })}
                  id="exportAsPdfBtn"
                >
                  Export to Pdf
                </Button>
              </Box>
              <Box>
                <Button
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => {
                    setShowTable(false)
                    printClick(false)
                  }}
                  id="PrintBtn"
                  onKeyDown={(e) => navigation3(e, 'fromDate', 'exportAsPdfBtn', () => { generatepdf(false) })}
                >
                  Print
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Box>
                <Button
                  id="backBtn"
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => { setShowTable(true); }}
                  onKeyDown={(e) => navigation3(e, 'fromDate', 'OwnSplitBtn', () => { setShowTable(true); focusElemnt('OwnSplitBtn') })}
                >
                  Back
                </Button>
              </Box>
            </>
          )}
        </Item>
      </Item>
      {showTable ? (
        <>
          <Stack sx={{ marginLeft: 2, marginRight: 2, height: 430, paddingTop: '10px' }} >
            <TableContainer className="scroll" style={{ border: 'none',boxShadow:'none' }} component={Paper}>
              <Table style={{ display: 'none' }} id="table-to-xls" className="table1 table-Report" size="small" aria-label="a dense table">
                <TableHead style={{fontWeight: 'bold' }}>
                  <TableRow>
                    <TableCell className="reportTD" style={{ fontSize: '25px', fontWeight: '500', textAlign: 'left' }} colSpan={7}>
                      <h3 style={{ paddingLeft: '17px' }}>Report For: Booking Report -</h3>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '25px', fontWeight: '500', textAlign: 'left' }} colSpan={6}>
                      <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData.strCompanyName}</h3>
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {excelHeader1?.map((item, i) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: '#454646', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.value}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{moment(fromDate).format('MM/DD/YYYY')}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{moment(toDate).format('MM/DD/YYYY')}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{sourceCity?.SourceCityName}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={2}
                    >
                      <span>{sourceBranch?.SourceBranchName}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={2}
                    >
                      <span>{sourceBranchUser?.UserBooked}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{destinationCity?.DestCityName}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{destinationBranch?.DestBranchName}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{paymentType?.name}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{transactionType?.TransType}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{selReportView?.ReportView}</span>
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={1}
                    >
                      <span>{status?.LrStatus} </span>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <RenderTableExcel showHeader={false} header={headers} data={tableData} key1="sfer" key2="43t" key3="0srf-3wq"/>
              </Table>
              <RenderTable showHeader={false} header={headers} data={tableData} key1="fdr43" key2="fg4er3" key3="rwfef3"/>
            </TableContainer>
          </Stack>
        </>
      ) : (
          <>
            {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
            {load ? (
              <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
                <object
                  id="ownBooingDetailed"
                  type="application/pdf"
                  width="100%"
                  height="440"
                  title="MTLPL -Cargo System - After Transfer Summary Report"
                  aria-label="MTLPL -Cargo System - After Transfer Summary Report"
                ></object>
              </Box>
            ) : (
              ''
            )}
          </>
      )}
    </>
  )
}
export default OwnBookingSummary
